import React, { useCallback } from 'react';
import { MDText } from 'i18n-react';
import { useRouter } from 'next/router';

import { Button } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import { useIsLoadingFilter } from 'Stores/SavedFiltersActionsStore/SavedFiltersActionsStore';
import { useSetIsSavedSearchPillOpen } from 'Stores/SavedFiltersStore/SavedFiltersStore';
import type { OnCloseEvent } from 'Types/drawer';
import { applyCypressData } from 'Utilities/helpers';
import ROUTES from 'Utilities/routes';

import { POPOVER_GAEVENT_CONSTS } from '../SavedSearchPopoverContent/SavedSearchPopoverContent.consts';
import { triggerSavedSearchPopoverGAEvent } from '../SavedSearchPopoverContent/SavedSearchPopoverContent.helpers';

import LocalTexts from './SavedSearchFooter.texts.json';

import styles from './SavedSearchFooter.module.scss';

const LocalT = new MDText(LocalTexts);

export interface SavedSearchFooterProps {
	onClose: (event: OnCloseEvent) => void;
	showVehicleButtonText: string;
}

const SavedSearchFooter: React.FC<SavedSearchFooterProps> = ({ onClose, showVehicleButtonText }) => {
	const router = useRouter();
	const setIsSavedSearchPillOpen = useSetIsSavedSearchPillOpen();
	const isLoadingFilter = useIsLoadingFilter();
	const {
		minWidth: { breakpointContent: isDesktop },
	} = useBreakpoint();
	const buttonSize = isDesktop ? 'small' : 'medium';

	const onEditButtonClick = useCallback(
		(eventAction: string) => {
			void router.push(ROUTES.MANAGE_SAVED_SEARCH.href);
			triggerSavedSearchPopoverGAEvent(eventAction);
			setIsSavedSearchPillOpen(false);
		},
		[router, setIsSavedSearchPillOpen],
	);

	const onHover = (eventAction: string) => triggerSavedSearchPopoverGAEvent(eventAction);

	return (
		<div className={styles.footer}>
			<div onMouseEnter={() => onHover(POPOVER_GAEVENT_CONSTS.hoverEditButton)}>
				<Button
					label={LocalT.translate('editSavedSearch')}
					onClick={() => onEditButtonClick(POPOVER_GAEVENT_CONSTS.clickEditButton)}
					size={buttonSize}
					variant="secondary"
					{...applyCypressData(cypressIds.buttons.savedSearchPopoverEditButton)}
				/>
			</div>
			<div onMouseEnter={() => onHover(POPOVER_GAEVENT_CONSTS.hoverShowVehiclesButton)}>
				<Button
					label={!isLoadingFilter ? showVehicleButtonText : null}
					loading={isLoadingFilter}
					onClick={onClose}
					size={buttonSize}
					{...applyCypressData(cypressIds.buttons.savedSearchPopoverShowVehiclesButton)}
				/>
			</div>
		</div>
	);
};

export default SavedSearchFooter;
